import { ReactNode } from 'react';
import { CompleteRegisterDescription } from '@/modules/auth/pages/completeRegister/components/CompleteRegisterDescriptions';
import { TUserStatusBottomSheetData } from '../UserStatusBottomSheetContainer';

export const useHandleStatusBottomSheetMessage = (
  registerMessage: string | undefined,
  children:
    | ReactNode
    | ((__userStatusData: TUserStatusBottomSheetData) => ReactNode),
  userStatusData: TUserStatusBottomSheetData
) => {
  const isDisallowedActionBottomSheet = typeof children === 'function';
  const returnMessageLayout = () => {
    return (
      <>
        {registerMessage ? (
          <CompleteRegisterDescription
            message={registerMessage}
            shouldShowMessage={true}
          />
        ) : isDisallowedActionBottomSheet ? (
          children(userStatusData)
        ) : (
          children
        )}
      </>
    );
  };

  return {
    returnMessageLayout,
  };
};
